// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1OGb6","box":"WorkspacesBox_box__3nNvZ","node":"WorkspacesBox_node__22gWZ"};